module.exports = __webpack_public_path__ + "static/media/048-abkhazia.3e2b1555.svg";